import React, { useContext, useEffect, useState } from 'react';
import { PriceRowContextContainer } from '../price-row-context';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import { insertTableAds } from '../ads';
import { PriceRow } from '../price-row/row-types';
import { createOfferFromPriceItem } from '../utils';
import {
  OfferItemExperimentType,
  useMobileTopAdExperiment,
  useOurChoiceExperiment,
  useNewProductOfferItemExperiment,
} from 'src/hooks/experiments';
import { IPriceListBodyProps } from './types';
import { usePriceListContext } from '../price-list-context';
import { OurChoiceWrapper } from '../price-row/row-types/our-choice';
import { PriceList } from './styles';

const PriceListBody: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IPriceListBodyProps>
>> = props => {
  const {
    sortedPrices,
    showMorePrices,
    numberOfVisiblePrices,
    productName,
    productId,
    media,
    brand,
    priceDisplay,
    campaign,
    isPrimaryList,
  } = props;

  const { selectedFilters } = useContext(PriceListFilterContext);
  const { ourChoice } = usePriceListContext();

  const [
    ourChoiceExperimentIsEnabled,
    setOurChoiceExperimentIsEnabled,
  ] = useState(false);

  const [
    newOfferItemExperimentState,
    setNewOfferItemExperimentState,
  ] = useState<OfferItemExperimentType>(false);

  const experiment = useMobileTopAdExperiment();
  const newOfferItemExperiment = useNewProductOfferItemExperiment();
  const ourChoiceExperiment = useOurChoiceExperiment();

  useEffect(() => {
    setOurChoiceExperimentIsEnabled(ourChoiceExperiment);
    setNewOfferItemExperimentState(newOfferItemExperiment);
  }, [newOfferItemExperiment, ourChoiceExperiment]);

  return (
    <PriceList>
      {sortedPrices &&
        sortedPrices.length > 0 &&
        insertTableAds(
          sortedPrices
            .slice(0, showMorePrices ? undefined : numberOfVisiblePrices)
            .map((item, index) => {
              const rowKey = `${item.id}-${index}`;
              const offer = createOfferFromPriceItem(item, selectedFilters);
              const RowComponent = (
                <PriceRow
                  item={item}
                  index={index}
                  isInPrimaryList={isPrimaryList}
                />
              );
              const isOurChoice = ourChoice?.id === item.id;
              return (
                <PriceRowContextContainer
                  key={rowKey}
                  productId={productId}
                  productName={productName}
                  productImage={media?.first}
                  brand={brand}
                  priceDisplay={priceDisplay}
                  campaign={campaign}
                  showExpandButton
                  offer={offer}
                  position="offerList"
                  isOurChoice={isOurChoice}
                  isFeatured={Boolean(offer.featured && offer.externalUri)}
                  newOfferItemExperiment={newOfferItemExperimentState}
                >
                  {ourChoiceExperimentIsEnabled && isOurChoice ? (
                    <OurChoiceWrapper>{RowComponent}</OurChoiceWrapper>
                  ) : (
                    RowComponent
                  )}
                </PriceRowContextContainer>
              );
            }),
          experiment === 'no top ad + lift ad in price list'
        ).map(row => <li key={row.key}>{row}</li>)}
    </PriceList>
  );
};

export default PriceListBody;
